import type { Definition } from '@exodus/dependency-types';

import type { GetBuildMetadata } from '@/background/adapters/get-build-metadata';
import type { Analytics } from '../types.js';

type Dependencies = {
  analytics: Analytics;
  getBuildMetadata: GetBuildMetadata;
};

const createAnalyticsMetadataPlugin = ({
  analytics,
  getBuildMetadata,
}: Dependencies) => {
  const onUnlock = async () => {
    const { appId, version, platformName, env, mode } =
      await getBuildMetadata();

    analytics.setDefaultEventProperties({
      appId,
      appVersion: version,
      appBuild: env,
      appPlatform: platformName,
      appMode: mode,
    });
  };

  return {
    onUnlock,
  };
};

const analyticsMetadataPluginDefinition = {
  id: 'analyticsMetadataPlugin',
  type: 'plugin',
  factory: createAnalyticsMetadataPlugin,
  dependencies: ['analytics', 'getBuildMetadata'],
} as const satisfies Definition;

export default analyticsMetadataPluginDefinition;
